import ContentFlow from "@civicplus/preamble-ui-hcms/lib/ContentFlow";
import ContentList from "@civicplus/preamble-ui-hcms/lib/ContentList/ContentList";
import { useEffect, useState } from "react";
import { ContentTypesApi } from "@civicplus/hcms-api-sdk/dist/sdk";
import { withStyles } from "@material-ui/core/styles";
import { SnackbarProvider } from "notistack";
import { styles as snackBarStyles } from "@civicplus/preamble/lib/SnackBarContent/styles";

const StyledSnackbarProvider = withStyles(snackBarStyles)(SnackbarProvider);

const config = {
	appName: "civicrec-docupload",
	baseUrl: "https://content-review.civicplus.com",
	clientId: "default",
	clientSecret: "6FSeHoYFsp094Z2QEMqde7eKMCx6wrz5gDWevtLUxLY="
};

config.headers = { ...config.headers, "X-ResolveFlow": "true" };

const TestPlanning = () => {
   const [id, setId] = useState();
   const [version, setVersion] = useState(0);
   const [contentTypes, setContentTypes] = useState([]);
   const [selectedContentType, setSelectedContentType] = useState({ label: "testcase", value: "testcase" });
   const [selectedPermissionSet, setSelectedPermissionSet] = useState({ label: "broadmoor", value: "broadmoor" });
   const [selectedStatus, setSelectedStatus] = useState({ label: "Open", value: "Open"});

   useEffect(() => {
      const fetchContentTypes = async () => {
         const schemaApi = new ContentTypesApi(config);
         const schemas = await schemaApi.getContentTypes(config.appName);
         setContentTypes(schemas.items);
      };

      fetchContentTypes();
   }, []);

   return (
      <div>
         <h3>Test Case</h3>
         <p>
            Create new test case or update existing test cases
         </p>

         {selectedContentType && (
            <StyledSnackbarProvider>
               <>
                  <ContentList
                   key={`${selectedContentType.value}`}	
                   config={config}	
                   schema={selectedContentType.value}	
                   id={"contentList-contentFlowDemo"}	
                   onRowClick={(item) => {	
                      setId(item.id);	
                   }}	
                   pagination={{	
                      rowsPerPage: 10,	
                      rowsPerPageOptions: [10, 25, 50, 100],	
                   }}	
                   includeUnpublished={true}	
                />	
                <ContentFlow	
                  id={"contentFlowDemo"}	
                  config={config}	
                  key={`${version}:${id}:${selectedContentType.value}`}	
                  schema={selectedContentType.value}
                  contentId={id}
                  onSave={(data) => {
                     setId(data.id);
                     setVersion(data.version);
                     setSelectedPermissionSet(data.permissionSet);
                  }}
                  onDraftCreated={(item) => {
                     setVersion(item.version);
                     setSelectedPermissionSet(item.permissionSet);
                     setSelectedStatus();
                  }}
                  onFailure={() => {}}
                  />
               </>
            </StyledSnackbarProvider>
         )}
      </div>
   );
};

<TestPlanning />;

export default TestPlanning;